'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
var React = require('react');
var AvatarName = require('./AvatarName.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var AvatarImage = function AvatarImage(props) {
  var src = props.src,
    onError = props.onError,
    getInitials = props.getInitials,
    name = props.name,
    borderRadius = props.borderRadius,
    loading = props.loading;

  /**
   * Use the image hook to only show the image when it has loaded
   */
  var status = react.useImage({
    src: src,
    onError: onError
  });
  var hasLoaded = status === 'loaded';

  /**
   * Fallback avatar applies under 2 conditions:
   * - If `src` was passed and the image has not loaded or failed to load
   * - If `src` wasn't passed
   *
   * In this case, we'll show either the name avatar or default avatar
   */
  var showFallback = !src || !hasLoaded;
  if (showFallback && name) {
    return /*#__PURE__*/React__default["default"].createElement(AvatarName.AvatarName, {
      className: "chakra-avatar__initials",
      getInitials: getInitials,
      name: name
    });
  }
  if (!src) {
    return null;
  }

  /**
   * If `src` was passed and the image has loaded, we'll show it
   */
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.img, {
    src: src,
    alt: name,
    className: "chakra-avatar__img",
    loading: loading,
    __css: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: borderRadius
    }
  });
};
AvatarImage.displayName = 'AvatarImage';
exports.AvatarImage = AvatarImage;